import { render } from "./index.vue?vue&type=template&id=62ce8fb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-62ce8fb0"

export default script